// custom history object for AuthContext, as useHistory router hook only works inside a component tree that's wrapped in a Router.
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

export default history;
